/* The renderer every page shares: pages render from window.SITE, written by
   snippets/site-data.liquid. data-page selects the renderer, data-side fixes the
   half; a page never asks the URL which half it is. */

  const S = window.SITE;
  const page = document.body.dataset.page;
  const SIDE = document.body.dataset.side || null;
  const PAGE = window.PAGE || {};

  /* theme assets are one flat folder on the CDN: shared/assets/brand/x.png is
     reached as ASSET_BASE + brand-x.png; an address already resolved, absolute
     or root relative, is left alone */
  function asset(path) {
    if (!path || !window.ASSET_BASE || /^((https?:)?\/\/|\/)/.test(path)) return path;
    const rel = path.replace(/^shared\/assets\//, '');
    return window.ASSET_BASE + rel.replace(/\//g, '-');
  }
  S.works.forEach(function (w) { w.image = asset(w.image); });
  S.makers.forEach(function (m) { m.portrait = asset(m.portrait); });
  S.posts.forEach(function (p) { p.hero_image = asset(p.hero_image); });
  /* metaobjects and articles come back in an order no admin control sets, so the
     ids keep the written order; the works keep the collection's own sort */
  function byId(a, b) { return (a._id || 0) - (b._id || 0); }
  S.makers.sort(byId); S.posts.sort(byId);

  const ROUTES = PAGE.routes || { root: '/', products: '/collections/products', posts: '/pages/posts', legal: '/pages/legal' };
  const SETTINGS = PAGE.settings || {};
  function setting(key, fallback) {
    const v = SETTINGS[key];
    return (v === undefined || v === null || v === '') ? fallback : v;
  }

  const makerById = {}, workById = {}, postById = {};
  S.makers.forEach(function (m) { makerById[m.id] = m; });
  S.works.forEach(function (w) { workById[w.id] = w; });
  S.posts.forEach(function (p) { postById[p.id] = p; });

  function fmtKRW(n) { return '₩ ' + n.toLocaleString('en-US'); }
  /* the theme's one escape, reached as a global by every later script: null
     escapes to '', never the word 'null', so a missing value cannot become a
     claim on the page, and the quote is escaped because callers write into
     attributes as well as into text */
  function esc(s) { return s == null ? '' : String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function param(k) { return new URLSearchParams(location.search).get(k); }

  /* ?shot stills the site for a photograph; everything that reads it is motion a
     still frame cannot hold */

  /* `maker` is the half's own word, the theme's structure rather than an editable
     label; the collective's index and item pages are gone, so its doors lead to
     the posts */
  const HALF = {
    collective: { list: ROUTES.posts, item: ROUTES.posts, plural: 'artworks', maker: 'artist' },
    selective:  { list: ROUTES.products, item: ROUTES.root + 'products/', plural: 'products', maker: 'designer' }
  };

  function listHref(side, q) { return HALF[side].list + (q ? '?' + q : ''); }
  /* a product is its own page; a collective work still opens the posts index */
  function itemHref(w) { return w.side === 'selective' ? HALF.selective.item + w.id : HALF.collective.item; }
  /* the profile page is gone; every post opens as an event page for now */
  function postHref(p) {
    return p.url || (ROUTES.posts + '/' + p.id);
  }
  /* a post's half is its first-named maker's, never its own; a post can name none
     (Made by is a metafield with no required flag), and then the word goes
     missing rather than the post */
  function postSide(p) {
    const m = (p.maker_ids || []).map(function (id) { return makerById[id]; }).find(Boolean);
    return m ? m.side : null;
  }
  /* indexing HALF unchecked here threw, and not locally to the record that caused it */
  function postKind(p) {
    if (p.type === 'exhibition') return 'exhibition';
    const half = HALF[postSide(p)];
    return half ? half.maker : '';
  }

  /* a value with no vocab entry shows itself, so a new one becomes a working
     option with nothing deployed */
  function said(field, value) {
    const v = (S.vocab || []);
    for (let i = 0; i < v.length; i++) {
      if (v[i].field === field && v[i].value === value) return v[i].name || value;
    }
    return value;
  }
  /* the class is the theme's, the word is the store's */
  const STATUS_CLASS = { 'sold': 'is-sold' };
  function statusOf(value) {
    return { label: said('status', value), cls: STATUS_CLASS[value] || '' };
  }

  function firstImageWork(workIds) {
    for (let i = 0; i < workIds.length; i++) {
      const w = workById[workIds[i]];
      if (w && w.image) return w;
    }
    return workById[workIds[0]] || null;
  }

  function makerNames(ids) {
    return ids.map(function (id) { return makerById[id] ? makerById[id].name : id; }).join(' · ');
  }

  function detailSrcs(w) {
    const out = (w.images && w.images.length) ? w.images.slice() : (w.image ? [w.image] : []);
    /* a work without extra photographs calls up its maker's other pieces, so
       pointing at a row always answers with something */
    if (out.length < 3) {
      S.works.forEach(function (o) {
        if (o.id !== w.id && o.maker_id === w.maker_id && o.image && out.indexOf(o.image) < 0) {
          out.push(o.image);
        }
      });
    }
    return out;
  }

  /* every shown work, carrying the show it belongs to */
  function shownWorks() {
    const out = [];
    exhRows().forEach(function (r) {
      (r.post.work_ids || []).forEach(function (id) {
        const w = workById[id];
        if (w && w.image) out.push({ work: w, post: r.post, state: r.state });
      });
    });
    return out;
  }

  /* date metafields serialise as YYYY-MM-DD, so these are LEXICAL comparisons on
     purpose: no parsing, no timezone, no day-out boundary for a Korean visitor */
  function periodRun(p) {
    const a = p.period_start ? p.period_start.replace(/-/g, '.') : '';
    const b = p.period_end ? p.period_end.replace(/-/g, '.') : '';
    return a && b ? a + ' \u2013 ' + b : (a || b);
  }

  function periodState(p) {
    if (p.type !== 'exhibition') return null;
    if (!p.period_start && !p.period_end) return null;
    const today = new Date().toISOString().slice(0, 10);
    if (p.period_end && p.period_end < today) return 'closed';
    if (p.period_start && p.period_start > today) return 'upcoming';
    return 'on view';
  }

  /* a show with no dates has no state, and says nothing rather than claiming to
     be open */
  function exhRows() {
    return S.posts.filter(function (p) { return p.type === 'exhibition'; }).map(function (p) {
      return { post: p, state: periodState(p), work: firstImageWork(p.work_ids) };
    });
  }

  function setMicro(el, str) {
    el.textContent = str;
    el.classList.add('in');
  }

  const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Both are called, never cached: a reading taken once at wire time keeps answering
     for the window the page loaded in. */
  /* The phone is its shorter side, not its width: held on its side it is wider than
     the gate and still a phone, and only a touch screen answers the second arm. Every
     stylesheet spells this same list at its phone query head. */
  function isPhone() { return window.matchMedia('(max-width: 600px), ((hover: none) and (max-height: 500px))').matches; }
  /* At exactly 900 both the (max-width: 900px) and (min-width: 900px) families apply
     at once, so wide sides with the max-width family and is written as a negation. */
  function isWide() { return !window.matchMedia('(max-width: 900px)').matches; }
  /* Choreography and the layers it needs key on hover, layout with nothing
     choreographed behind it on width: a tablet held wide is isWide() and takes
     the phone's choreography (isTouch) instead. */
  function isDesktop() { return isWide() && window.matchMedia('(hover: hover)').matches; }
  /* the phone's choreography runs on the phone and on every touch screen
     (mobile.css's own query), so a narrowed window with a mouse keeps it */
  function isTouch() { return isPhone() || window.matchMedia('(hover: none)').matches; }

  /* ---------- the crumb path ---------- */
  function crumbSide(side) {
    return { label: side, href: HALF[side].list,
      options: ['collective', 'selective'].map(function (s) {
        return { label: s, href: HALF[s].list, on: s === side };
      }) };
  }

/* wiring: ports as-is */

  /* ---------- scroll with tension ---------- */
  /* kept where the scroll mark can reach it: dragging the mark must move the page
     through whatever drives the scroll, or the two fight over the position */
  let lenis = null;

  function wireSmoothScroll() {
    if (typeof Lenis === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (param('shot')) return;

    lenis = new Lenis({
      duration: 1.4,
      /* exponential out: the push spends at once and glides, which reads as weight */
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      orientation: 'vertical',
      smoothWheel: true
    });
    function raf(time) { requestAnimationFrame(raf); lenis.raf(time); }
    requestAnimationFrame(raf);

    wireTravel(document.querySelectorAll('.plate-img'), 50);

    /* not .exh or .lg: will-change/transform on an ancestor quietly turns their
       fixed and sticky furniture absolute, riding the section it should stand
       still against */
    const rise = Array.prototype.slice.call(
      document.querySelectorAll('main > section:not(.hero):not(.plate-stage):not(.exh):not(.dz):not(.lg)')
    );
    rise.forEach(function (el) { el.style.willChange = 'transform'; });

    /* the offset decays damped per frame rather than tied to the scroll, so the
       section arrives a moment after the scroll that called it */
    const state = rise.map(function () { return 0; });
    let vh = window.innerHeight;

    wireTravel(document.querySelectorAll('.rl-frame img'), 50);
    window.addEventListener('resize', function () { vh = window.innerHeight; }, { passive: true });

    (function tick() {
      requestAnimationFrame(tick);
      rise.forEach(function (el, i) {
        const box = el.getBoundingClientRect();
        /* 120px below its place while low on the screen, nothing past a tenth of
           the window */
        const t = (box.top - vh * 0.1) / Math.max(1, vh * 0.85);
        const want = Math.min(1, Math.max(0, t)) * 120;
        state[i] += (want - state[i]) * 0.08;
        el.style.transform = 'translate3d(0,' + state[i].toFixed(2) + 'px,0)';
      });
    })();
  }

  /* the frame holds the picture larger by exactly the travel distance, or it
     would show its own floor at the ends of the pass */
  const NATIVE_TIMELINE = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');

  function wireTravel(nodes, amount) {
    const media = Array.prototype.slice.call(nodes);
    if (!media.length || !isDesktop()) return;
    /* the fallback below is the same curve, driven by hand */
    if (NATIVE_TIMELINE) {
      media.forEach(function (el) {
        el.style.setProperty('--travel', amount + '%');
        el.style.setProperty('--travel-scale', (1 + amount / 100 + 0.04).toFixed(3));
        el.classList.add('travels');
      });
      return;
    }
    const scale = 1 + amount / 100 + 0.04;
    media.forEach(function (el) { el.style.willChange = 'transform'; });
    let vh = window.innerHeight;
    window.addEventListener('resize', function () { vh = window.innerHeight; }, { passive: true });
    (function tick() {
      requestAnimationFrame(tick);
      media.forEach(function (el) {
        const frame = el.parentNode;
        if (!frame) return;
        const box = frame.getBoundingClientRect();
        if (box.bottom < -200 || box.top > vh + 200) return;
        /* 0 as the frame enters at the foot of the window, 1 as it leaves the top */
        const p = 1 - Math.min(1, Math.max(0, (box.top + box.height) / (vh + box.height)));
        el.style.transform =
          'translate3d(0,' + ((p - 0.5) * amount).toFixed(2) + '%,0) scale(' + scale.toFixed(3) + ')';
      });
    })();
  }

  const CRUMB_HOME = { label: 'home', href: ROUTES.root };

  function wireCrumb(steps) {
    const el = document.getElementById('crumb');
    if (!el) return;
    el.innerHTML = steps.map(function (s) {
      let now = s.href
        ? '<a class="crumb-now" href="' + s.href + '">' + esc(s.label) + '</a>'
        : '<span class="crumb-now">' + esc(s.label) + '</span>';
      if (!s.options) return '<span class="crumb-seg">' + now + '</span>';
      /* a step that answers wears the drops' own caret: without it nothing
         says the options exist until a pointer happens to rest on the step */
      now += '<svg class="crumb-caret" viewBox="0 0 8 5" aria-hidden="true"><path d="M1 1 L4 4 L7 1" fill="none" stroke="currentColor"/></svg>';
      return '<span class="crumb-seg" tabindex="0">' + now +
        '<span class="crumb-opts">' +
        s.options.map(function (o) {
          return '<a href="' + o.href + '"' + (o.on ? ' class="on"' : '') + '>' + esc(o.label) + '</a>';
        }).join('') +
        '</span></span>';
    }).join('<span class="crumb-sep" aria-hidden="true">&gt;</span>');
    /* no hover under the finger: the first tap on a door with options opens its
       list (focus carries the :focus-within rule), the second goes through */
    if (window.matchMedia('(hover: none)').matches) {
      el.addEventListener('click', function (e) {
        const now = e.target.closest('.crumb-now');
        const seg = now && now.closest('.crumb-seg[tabindex]');
        if (!seg || seg.matches(':focus-within')) return;
        e.preventDefault();
        seg.focus();
      });
    }
  }

  /* ---------- the rail index follows the reading (legal, post-dossier) ----------
     While Lenis drives, jumps go through lenis.scrollTo or the two disagree about
     where the page is. opts: idx (nav holding the links), secs (sections in
     reading order), headroom (band top px, default 170/90), dot (travelling
     dot), bow (1 bends its arc right going down, -1 left). */
  function wireRailIndex(opts) {
    const idx = opts.idx;
    const secs = opts.secs || [];
    const links = Array.prototype.slice.call(idx ? idx.querySelectorAll('a') : []);
    if (!links.length || !secs.length) return;

    const linkFor = {};
    links.forEach(function (l) { linkFor[l.getAttribute('href').slice(1)] = l; });

    /* the travelling dot: the final position is committed as style so the
       animation needs no fill; atoms in assets/base.css */
    let dot = null, dotAt = -1;
    if (opts.dot) {
      /* a re-wire (the legal language toggle) must not leave the old dot stranded
         where its dead listener parked it */
      const stranded = idx.querySelector('.idx-dot');
      if (stranded) stranded.remove();
      idx.classList.add('idx-gutter');
      dot = document.createElement('span');
      dot.className = 'idx-dot';
      dot.setAttribute('aria-hidden', 'true');
      idx.appendChild(dot);
      window.addEventListener('resize', seatDot);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(seatDot);
    }

    function dotY(i) { return links[i].offsetTop + links[i].offsetHeight / 2 - 3; }

    function seatDot() {
      if (dot && dotAt >= 0) dot.style.transform = 'translateY(' + dotY(dotAt) + 'px)';
    }

    function sendDot(i) {
      if (i === dotAt || i < 0) return;
      const from = dotAt;
      dotAt = i;
      const y = dotY(i);
      const jump = from < 0 || !dot.animate ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!jump) {
        const y0 = dotY(from);
        const bulge = (i > from ? 6 : -6) * (opts.bow || 1);
        dot.animate([
          { transform: 'translate(0px, ' + y0 + 'px)' },
          { transform: 'translate(' + bulge + 'px, ' + (y0 + y) / 2 + 'px)' },
          { transform: 'translate(0px, ' + y + 'px)' }
        ], { duration: 250, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' });
      }
      dot.style.transform = 'translateY(' + y + 'px)';
    }

    function mark(id) {
      if (!linkFor[id]) return;
      idx.classList.add('live');
      links.forEach(function (l) { l.classList.toggle('on', l === linkFor[id]); });
      if (dot) sendDot(links.indexOf(linkFor[id]));
    }

    /* the band's top, the same distance scroll-margin-top gives every jump;
       a phone is a phone before it is wide, or a phone held sideways reads the
       desk's number */
    const headroom = opts.headroom || function () {
      return isWide() && !isPhone() ? 170 : 90;
    };

    /* ---------- click-intent lock ----------
       A click holds the band's marking until the scroll rests at the destination;
       the rest test wants quiet samples with no fresh band news, so no mid-glide
       callback lands after the hold lifts. A wheel releases it only when the
       page can move that way: one against a reached edge is momentum still
       streaming from before the click, and Lenis drops its glide for any wheel
       at all, so the poll renews an aim lost to that residue. */
    let lock = null, held = -1, ioAt = 0;

    function releaseLock() {
      if (!lock) return;
      clearInterval(lock.poll);
      clearTimeout(lock.stop);
      lock = null;
    }

    function lockTo(id, dest, target) {
      releaseLock();
      let still = 0, last = window.scrollY;
      function settle() {
        releaseLock();
        mark(id);
        held = window.scrollY;
        /* an aim taken while the footer stage held main aloft lands a stage
           short; re-aim once from rest, only on overshoot above the line */
        if (!target || typeof lenis === 'undefined' || !lenis) return;
        const err = target.getBoundingClientRect().top - headroom();
        if (err < -4) {
          const dest2 = Math.max(0, window.scrollY + err);
          lockTo(id, dest2, null);
          lenis.scrollTo(dest2);
        }
      }
      lock = {
        poll: setInterval(function () {
          const y = window.scrollY;
          still = Math.abs(y - last) < 1 ? still + 1 : 0;
          last = y;
          if (typeof lenis !== 'undefined' && lenis &&
            Math.abs(lenis.targetScroll - dest) > 2) lenis.scrollTo(dest);
          if (still >= 3 && Math.abs(y - dest) <= 2 &&
            performance.now() - ioAt > 200) settle();
        }, 80),
        /* past the glide's 1.4s plus rest detection, so an interrupted scroll
           cannot wedge the hold */
        stop: setTimeout(settle, 2000)
      };
    }

    /* momentum keeps an unbroken cadence with fading force; intent pushes harder
       than the last event or arrives after a pause */
    let wheelMag = 0, wheelAt = 0;
    window.addEventListener('wheel', function (e) {
      const now = performance.now();
      const mag = Math.abs(e.deltaY);
      const fresh = now - wheelAt > 150 || mag > wheelMag;
      wheelAt = now;
      wheelMag = mag;
      if (!lock || !fresh) return;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const canMove = e.deltaY < 0 ? window.scrollY >= 1 : window.scrollY <= max - 1;
      if (canMove) releaseLock();
    }, { passive: true });
    window.addEventListener('touchstart', releaseLock, { passive: true });

    links.forEach(function (l) {
      l.addEventListener('click', function (e) {
        const id = l.getAttribute('href').slice(1);
        const target = document.getElementById(id);
        if (!target) return;
        mark(id);
        /* a number, not the element: Lenis would add scroll-margin-top on top */
        const max = document.documentElement.scrollHeight - window.innerHeight;
        const dest = Math.max(0, Math.min(
          target.getBoundingClientRect().top + window.scrollY - headroom(), max));
        lockTo(id, dest, target);
        /* no lenis: the browser takes the hash itself */
        if (typeof lenis === 'undefined' || !lenis) return;
        e.preventDefault();
        history.pushState(null, '', '#' + id);
        lenis.scrollTo(dest);
      });
    });

    /* the band may not have fired yet, so a landing hash sets the entry first */
    const here = location.hash.slice(1);
    mark(linkFor[here] ? here : secs[0].id);

    if (!('IntersectionObserver' in window)) return;
    const inBand = {};

    /* a last section shorter than the headroom never crosses the line, so the
       foot of the document elects the last entry instead */
    function atEnd() {
      /* a page too short to scroll is not at its end: the topmost visible entry
         wins there */
      if (window.scrollY <= 0) return false;
      return window.scrollY >=
        document.documentElement.scrollHeight - window.innerHeight - 4;
    }

    function elect() {
      /* a click in flight, or one whose rest the reader has not left, owns the mark */
      if (lock || held >= 0) return;
      if (atEnd()) { mark(secs[secs.length - 1].id); return; }
      /* topmost visible wins: first hit in document order */
      for (let i = 0; i < secs.length; i++) {
        if (inBand[secs[i].id]) { mark(secs[i].id); return; }
      }
    }

    const io = new IntersectionObserver(function (entries) {
      ioAt = performance.now();
      entries.forEach(function (en) { inBand[en.target.id] = en.isIntersecting; });
      elect();
    }, { rootMargin: '-' + headroom() + 'px 0px -55% 0px' });
    secs.forEach(function (s) { io.observe(s); });

    /* crossing on or off the sheet's end moves no section boundary, and only real
       travel proves the reader has left a click's rest */
    window.addEventListener('scroll', function () {
      if (held >= 0 && !lock && Math.abs(window.scrollY - held) > 24) held = -1;
      elect();
    }, { passive: true });
  }

  /* the mark machinery, shared by the plate and the menu (prefix pd|mn) */

  /* mayBloom: an optional gate; the plate holds the latch shut until its mark has
     finished aligning */
  function wireGlossLatch(root, prefix, mayBloom) {
    prefix = prefix || 'pd';
    const pairs = [['dot', 'collective'], ['arc', 'selective']].map(function (pair) {
      return {
        hit: root.querySelector('.' + prefix + '-hit-' + pair[0]),
        gloss: root.querySelector('.' + prefix + '-gloss-' + pair[1]),
        timer: 0, intent: 0
      };
    }).filter(function (p) { return p.hit && p.gloss; });
    pairs.forEach(function (p, i) {
      const other = pairs[1 - i];
      function bloom() {
        if (mayBloom && !mayBloom()) return;
        clearTimeout(p.timer);
        /* the other folds BEFORE this one lights: both lit for even a style frame
           and each side's quieting rule sees the other, dipping the whole plate */
        if (other) { clearTimeout(other.timer); other.gloss.classList.remove('lit'); }
        p.gloss.classList.add('lit');
      }
      /* the zones overlap, so a hand leaving one half crosses the other; only a
         hand that stays a beat is answered */
      function arm() {
        clearTimeout(p.intent);
        p.intent = setTimeout(bloom, 170);
      }
      function fold() {
        clearTimeout(p.intent);
        clearTimeout(p.timer);
        p.timer = setTimeout(function () { p.gloss.classList.remove('lit'); }, 1600);
      }
      [p.hit, p.gloss].forEach(function (el) {
        el.addEventListener('pointerenter', arm);
        el.addEventListener('pointerleave', fold);
      });
    });
  }

  /* the retrace stepper, pure and left on window: playback rides rAF, which a
     headless probe is never granted, so the probe drives this directly */
  function retraceAt(journey, elapsed, swell) {
    /* near-constant duration, not constant pace: paced by length a wild spin took
       ten seconds home and a flick snapped back */
    let L = [0], total = 0, j, a, b;
    for (j = 1; j < journey.length; j++) {
      a = journey[j - 1]; b = journey[j];
      total += Math.sqrt((b.p - a.p) * (b.p - a.p) + (b.y - a.y) * (b.y - a.y));
      L.push(total);
    }
    const first = journey[0];
    const play = Math.max(1300, Math.min(1300 + total * 2.4, 2600));
    if (total <= 0 || elapsed >= play) return { p: first.p, y: first.y, done: true };
    /* quick through each arc's middle, hanging at the turns; swell leans harder */
    let u = elapsed / play;
    const k = Math.max(2, Math.round(play / 2200));
    u = u - ((swell ? 0.6 : 0.45) / (2 * Math.PI * k)) * Math.sin(2 * Math.PI * k * u);
    /* tail-first: the distance still to be untold shrinks as u grows */
    const d = (1 - u) * total;
    let i = 1;
    while (i < journey.length - 1 && L[i] < d) i++;
    a = journey[i - 1]; b = journey[i];
    const f = (d - L[i - 1]) / ((L[i] - L[i - 1]) || 1);
    return { p: a.p + (b.p - a.p) * f, y: a.y + (b.y - a.y) * f, done: false };
  }

  window.__retraceAt = retraceAt;

  /* the mode defaults to the body's ?mark switch; the menu passes its own */
  function wireMarkTumble(plate, mode, prefix) {
    if (REDUCE || param('shot')) return;
    mode = mode || document.body.dataset.mark;
    prefix = prefix || 'pd';
    const retraces = mode === 'tumble4';
    const swell = mode === 'tumble4';
    [['dot', 'logo-dot'], ['arc', 'logo-arc']].forEach(function (pair) {
      const hit = plate.querySelector('.' + prefix + '-hit-' + pair[0]);
      const half = plate.querySelector('img.' + pair[1]);
      if (!hit || !half) return;
      /* degrees of tumble per pixel of drag */
      const TURN = 0.5;
      let pitch = 0, yaw = 0, held = false, homeTimer = 0;
      let moved = 0, caught = false, downX = 0, downY = 0, lastX = 0, lastY = 0;
      /* the record of the journey, and the clock of its playback */
      let journey = [], raf = 0, playT0 = 0;
      if (retraces) half.__journey = journey;
      function turn() {
        half.style.transform = 'rotateX(' + pitch + 'deg) rotateY(' + yaw + 'deg)';
      }
      function record() {
        journey.push({ t: performance.now(), p: pitch, y: yaw });
        /* bounded: over the cap every other interior sample drops, keeping the
           endpoints; older than ten seconds is let go */
        if (journey.length > 600) {
          for (let i = journey.length - 2; i > 0; i -= 2) journey.splice(i, 1);
        }
        while (journey.length > 2 &&
               journey[journey.length - 1].t - journey[1].t > 10000) {
          journey.splice(1, 1);
        }
      }
      function playFrame() {
        const s = retraceAt(journey, performance.now() - playT0, swell);
        /* a light low-pass: replayed pointer corners read as jitter; the endpoint
           snaps exact when the stepper says done */
        if (s.done) { pitch = s.p; yaw = s.y; }
        else { pitch += (s.p - pitch) * 0.25; yaw += (s.y - yaw) * 0.25; }
        turn();
        if (!s.done) { raf = requestAnimationFrame(playFrame); return; }
        raf = 0;
        journey.length = 0;
        half.classList.remove('pd-retrace');
        /* chained grabs can start a journey away from flat; the last stretch home
           from its first sample is the ordinary long rein */
        if (pitch === 0 && yaw === 0) { half.style.transform = ''; return; }
        half.classList.add('pd-home');
        half.style.transform = 'rotateX(0deg) rotateY(0deg)';
      }
      function startRetrace() {
        /* a journey of one sample has nothing to replay, but the half may still
           be tilted from the grab that wrote it: the long rein takes it home */
        if (journey.length < 2) {
          journey.length = 0;
          if (pitch !== 0 || yaw !== 0) {
            half.classList.add('pd-home');
            half.style.transform = 'rotateX(0deg) rotateY(0deg)';
          }
          return;
        }
        half.classList.add('pd-retrace');
        playT0 = performance.now();
        raf = requestAnimationFrame(playFrame);
      }
      hit.addEventListener('pointerdown', function (e) {
        if (e.button) return;
        held = true; moved = 0;
        /* a press on a half not at rest is an interception, not a click: the
           caught half leaves from under a motionless pointer, so the 6px rule
           alone would let the grab fall through to the link */
        caught = raf !== 0 || half.classList.contains('pd-home') ||
          pitch !== 0 || yaw !== 0;
        downX = lastX = e.clientX; downY = lastY = e.clientY;
        clearTimeout(homeTimer);
        /* a catch stops the replay where it stands; the drag resumes from the
           played-back angles and keeps writing into the same journey */
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        half.classList.remove('pd-retrace');
        half.classList.remove('pd-home');
        turn();
        if (retraces) record();
        /* a synthetic pointer has no capture to take; the real one must be held */
        try { hit.setPointerCapture(e.pointerId); } catch (err) { /* probe events */ }
      });
      hit.addEventListener('pointermove', function (e) {
        if (!held) return;
        moved = Math.max(moved, Math.abs(e.clientX - downX) + Math.abs(e.clientY - downY));
        yaw += (e.clientX - lastX) * TURN;
        /* screen y runs down, so the lift that tips the top away runs against it */
        pitch -= (e.clientY - lastY) * TURN;
        lastX = e.clientX; lastY = e.clientY;
        turn();
        if (retraces) record();
      });
      function drop() {
        if (!held) return;
        held = false;
        clearTimeout(homeTimer);
        /* the adjusted half is left standing long enough to be read as a state
           the hand has set, not a bounce, before the way home begins */
        homeTimer = setTimeout(retraces ? startRetrace : function () {
          half.classList.add('pd-home');
          half.style.transform = 'rotateX(0deg) rotateY(0deg)';
        }, 2000);
      }
      hit.addEventListener('pointerup', drop);
      hit.addEventListener('pointercancel', drop);
      /* home again, the memory and the inline angles stand down together */
      half.addEventListener('transitionend', function (e) {
        if (e.propertyName !== 'transform' || held || !half.classList.contains('pd-home')) return;
        pitch = 0; yaw = 0;
        half.classList.remove('pd-home');
        half.style.transform = '';
      });
      /* a tumble must not also open the door it started on */
      hit.addEventListener('click', function (e) { if (moved > 6 || caught) e.preventDefault(); }, true);
      hit.addEventListener('dragstart', function (e) { e.preventDefault(); });
      /* the menu closes over its mark mid-gesture; reopening must find the halves
         home, with nothing of the old journey left to walk */
      half.__markReset = function () {
        held = false;
        clearTimeout(homeTimer);
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        journey.length = 0;
        pitch = 0; yaw = 0;
        half.classList.remove('pd-retrace');
        half.classList.remove('pd-home');
        half.style.transform = '';
      };
    });
  }
